module.exports = __webpack_public_path__ + "static/media/about.a0d44515.svg";